<template>
  <PageLayout>
    <m-page-header :title="$t(`apply.title.checkData`)"></m-page-header>
    <m-form ref="form">
      <!-- 申請人信息 -->
      <template>
        <m-folding-panel
          :title="$t(`apply.title.applicationInfo`)"
          enableCollapsed
          :active="true"
          :class="`rainbow__folding__panel rainbow__page0`"
        >
          <m-cell vertical>
            <m-row :gutter="24">
              <m-col span="24">
                <m-cell-item
                  class="cellColor"
                  :label="this.$t('apply.title.applyType')"
                  :value="
                    this.$t(`apply.title.${form.applicationType}`) +
                    `(${getCompanyType(form.companyType)})`
                  "
                ></m-cell-item>
              </m-col>
            </m-row>
            <m-row :gutter="24">
              <m-col :span="24">
                <m-cell-item
                  :label="this.$t('apply.title.surname')"
                  :value="form.surname"
                ></m-cell-item>
              </m-col>
            </m-row>
            <m-row :gutter="24">
              <m-col :span="24">
                <m-cell-item
                  :label="this.$t('apply.title.givenName')"
                  :value="form.givenName"
                ></m-cell-item>
              </m-col>
            </m-row>

            <m-row :gutter="24">
              <m-col :span="24">
                <m-cell-item
                  :label="this.$t('apply.title.certificateType')"
                  :value="getIdCardType(form.idCardType)"
                ></m-cell-item>
              </m-col>
            </m-row>
            <m-row :gutter="24">
              <m-col :span="24">
                <m-cell-item
                  :label="this.$t('apply.title.IDNumber')"
                  :value="form.cardNo"
                ></m-cell-item>
              </m-col>
            </m-row>
          </m-cell>
        </m-folding-panel>
      </template>

      <!-- 公司信息 -->
      <template>
        <m-folding-panel
          :title="$t(`apply.title.companyInfo`)"
          enableCollapsed
          :active="true"
          :class="`rainbow__folding__panel rainbow__page1`"
        >
          <m-cell vertical>
            <m-row :gutter="24">
              <m-col :span="24">
                <m-cell-item
                  :label="this.$t('apply.title.companyName')"
                  :value="form.companyName"
                ></m-cell-item>
              </m-col>
            </m-row>

            <m-row :gutter="24">
              <m-col :span="24">
                <m-cell-item
                  :label="this.$t('apply.title.companyCertificateType')"
                  :value="getIdCardType(form.entityType)"
                ></m-cell-item>
              </m-col>
            </m-row>

            <m-row :gutter="24">
              <m-col :span="24">
                <m-cell-item
                  :label="this.$t('apply.title.companyIDNumber')"
                  :value="form.companyCode"
                ></m-cell-item>
              </m-col>
            </m-row>

            <m-row :gutter="24">
              <m-col :span="24">
                <m-cell-item
                  :label="this.$t('apply.title.taxNum')"
                  :value="form.taxNo"
                ></m-cell-item>
              </m-col>
            </m-row>
            <m-row :gutter="24">
              <m-col :span="24">
                <m-cell-item
                  :label="this.$t('apply.title.contactInfo')"
                  :value="form.contact"
                ></m-cell-item>
              </m-col>
            </m-row>
            <m-row :gutter="24">
              <m-col span="24">
                <m-cell-item
                  :label="this.$t('apply.title.address')"
                  :value="form.address"
                ></m-cell-item>
              </m-col>
            </m-row>
            <m-row :gutter="24">
              <m-col span="24">
                <m-cell-item
                  :label="this.$t('apply.title.contactNumber1')"
                  :value="form.areaCode + form.mobile"
                ></m-cell-item>
              </m-col>
            </m-row>
          </m-cell>
        </m-folding-panel>
      </template>

      <!-- 場所資料 -->
      <template>
        <m-folding-panel
          :title="$t(`apply.title.venueData`)"
          enableCollapsed
          :active="true"
          :class="`rainbow__folding__panel rainbow__page2`"
        >
          <m-cell>
            <m-row :gutter="24">
              <m-col :span="24">
                <m-cell-item
                  :label="this.$t('apply.title.venueName')"
                  :value="form.siteName"
                ></m-cell-item>
              </m-col>
            </m-row>
            <m-row :gutter="24">
              <m-col :span="24">
                <m-cell-item
                  class="cellBreak"
                  :label="this.$t('apply.title.staffNumber')"
                  :value="form.staffNum"
                ></m-cell-item>
              </m-col>
            </m-row>
            <m-row :gutter="24">
              <m-col :span="24">
                <m-cell-item
                  :label="this.$t('apply.title.openDate')"
                  :value="form.openDate"
                ></m-cell-item>
              </m-col>
            </m-row>
            <m-row :gutter="24">
              <m-col :span="24">
                <m-cell-item
                  class="cellBreak"
                  :label="this.$t('apply.title.businessTime')"
                  :value="form.businessHours"
                ></m-cell-item>
              </m-col>
            </m-row>
            <m-row :gutter="24">
              <m-col span="24">
                <m-cell-item
                  class="cellBreak"
                  :label="this.$t('apply.title.venueLocation')"
                  :value="form.siteAddress"
                ></m-cell-item>
              </m-col>
            </m-row>
          </m-cell>
        </m-folding-panel>
      </template>

      <!-- 圖片 -->
      <template>
        <m-folding-panel
          :title="$t(`apply.title.fileImg`)"
          enableCollapsed
          :active="true"
          :class="`rainbow__folding__panel rainbow__page3 collapse-header`"
        >
          <m-row :gutter="24">
            <div v-for="(item, index) in form.documentTypes" :key="index">
              <m-folding-panel
                v-if="
                  item.mailingType === 'update1' || item.fileList?.length > 0
                "
                :key="`upload-${index}`"
                :title="isZHHANT ? item.nameCn : item.namePt"
                enableCollapsed
                :active="true"
                :class="`rainbow__folding__panel rainbow__2page${index % 4}`"
              >
                <m-upload
                  v-if="!item.mailing || item.mailingType === 'update2'"
                  isFormItem
                  :file-list="item.fileList"
                  layout="vertical"
                  :show-upload-list="{ showRemoveIcon: false }"
                  @preview="handlePreview"
                >
                </m-upload>
                <m-cell vertical>
                  <m-row :gutter="24" v-if="item.mailing">
                    <m-col span="24">
                      <!-- <div>{{ isZHHANT() ? item.nameCn : item.namePt }}</div> -->
                      <div>
                        {{
                          item.mailingType
                            ? `${$t(`updateTypeList.${item.mailingType}`)}`
                            : ''
                        }}
                      </div>
                    </m-col>
                  </m-row>
                </m-cell>
              </m-folding-panel>
            </div>
          </m-row>
        </m-folding-panel>
      </template>
      <!-- 一次性密碼 -->
      <template>
        <m-folding-panel
          :title="$t('apply.title.SMSCode')"
          enableCollapsed
          :active="true"
          :class="`rainbow__folding__panel rainbow__page3`"
        >
          <m-cell>
            <m-input
              is-form-item
              :maxLength="6"
              v-model="form.otp"
              :placeholder="$t('apply.message.inPutSMSCode')"
              :label="$t('apply.title.SMSCode')"
              :rules="[
                { required: true, message: $t('apply.message.inPutSMSCode') },
              ]"
            >
              <template v-slot:contentSuffix>
                <m-button
                  style="margin-left: 10px"
                  type="primary"
                  size="small"
                  @click="sendSMS"
                  :disabled="countdown > 0 ? true : false"
                  >{{ timeTip }}</m-button
                >
              </template>
            </m-input>
          </m-cell>
        </m-folding-panel>
      </template>
    </m-form>
    <PdfViewr
      :visible="pdfVisible"
      :blobUrl="pdfBlobUrl"
      @close="handleClose"
    />
  </PageLayout>
</template>
  
  <script>
import PageLayout from 'common/components/Layout/web/PageLayout.vue';
import { ApplyAPI, CaptchaAPI } from '@/api';
import { formatbytes } from 'govmo-common/src/utils/bytes';
import {
  getSpan,
  getCompanyType,
  getIdCardType,
  isZHHANT,
} from 'govmo-common/src/utils/utils';
import { FileAPI } from '@/api';
import {
  convertToBlob,
  blobToFiles,
  viewImages,
} from 'govmo-common/src/utils/file';
import PdfViewr from '@/components/PdfViewr.vue';

function debounce(func, wait) {
  let timer;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}
export default {
  components: {
    PageLayout,
    PdfViewr,
  },
  props: {
    formData: {
      type: Object,
    },
  },
  data() {
    return {
      form: {},
      submitData: {},
      timeTip: this.$t('apply.button.receive'),
      countdown: 0,
      timer: 0,
      intervalId: null,
      pdfVisible: false,
      pdfBlobUrl: '',
    };
  },
  filters: {
    formatbytes,
  },
  computed: {
    isCounting() {
      return this.countdown > 0;
    },
  },
  beforeDestroy() {
    this.intervalId && clearInterval(this.intervalId);
    this.handleClose();
  },
  methods: {
    isZHHANT,
    getSpan,
    getCompanyType,
    getIdCardType,
    //倒計時
    startCountdown: debounce(async function () {
      if (this.isCounting) return;

      this.countdown = 60;
      this.updateTimeTip();

      const interval = setInterval(() => {
        this.countdown -= 1;
        this.updateTimeTip();

        if (this.countdown <= 0) {
          clearInterval(interval);
        }
      }, 1000);
    }, 500),
    updateTimeTip() {
      if (this.countdown > 0) {
        this.timeTip = this.$t('apply.title.receiveAgain', {
          number: this.countdown,
        });
      } else {
        this.timeTip = this.$t('apply.button.receive');
      }
    },
    // startCountdown: debounce(async function () {
    //   this.intervalId && clearInterval(this.intervalId);
    //   this.timer = 60;
    //   this.intervalId = setInterval(() => {
    //     if (this.timer > 0) {
    //       this.timer -= 1;
    //       this.timeTip = this.$t('apply.title.receiveAgain', {
    //         number: this.timer,
    //       });
    //     } else {
    //       this.intervalId = null;
    //       clearInterval(this.intervalId);
    //       this.timeTip = this.$t('apply.button.receive');
    //     }
    //   }, 1000);
    // }, 500),
    async sendSMS() {
      try {
        this.$showLoading();
        let apiAreaCode = this.form.areaCode?.replace(/\+/g, '');
        await CaptchaAPI.getSMS({
          mobile: apiAreaCode + this.form.mobile,
          applicationNo: this.form.applicationNo,
        });
        this.startCountdown();
      } catch (error) {
        this.$error(error);
      } finally {
        this.$hideLoading();
      }
    },
    onPrevious() {
      this.$emit('previous');
    },
    async onNext() {
      try {
        if (!(await this.$refs.form.validateFields())) return;
        this.$showLoading();
        // let documents = {};
        // this.form.documentTypes?.forEach((item) => {
        //   item.fileList?.forEach((file) => {
        //     documents[`${file.tempId}`] = file.byte;
        //   });
        // });
        let apiAreaCode = this.form.areaCode?.replace(/\+/g, '');
        let value = {
          // ...this.form,
          address: this.form.address,
          applicationChannel: this.form.applicationChannel,
          applicationType: this.form.applicationType,
          applicationNo: this.form.applicationNo,
          areaCode: apiAreaCode,
          businessHours: this.form.businessHours,
          captcha: this.form.captcha,
          cardNo: this.form.cardNo,
          companyType: this.form.companyType,
          contact: this.form.contact,
          id: this.form.id,
          idCardType: this.form.idCardType,
          language: this.form.language,
          mobile: this.form.mobile,
          name: this.form.name,
          openDate: this.form.openDate,
          siteAddress: this.form.siteAddress,
          siteName: this.form.siteName,
          staffNum: this.form.staffNum,
          taxNo: this.form.taxNo,
          // documents: documents,
          surname: this.form.surname,
          givenName: this.form.givenName,
          companyCode: this.form.companyCode,
          entityType: this.form.entityType,
          companyName: this.form.companyName,
          status:
            'SUBMITTED' /*DRAFT-草稿 SUBMITTED-已提交 REMODIFY-須補交文件 PASSED-批核通過 NO_PASSED-批核不通過 CLOSED-已關閉【必填，默认 已提交】*/,
        };
        //提交
        this.submitData = await ApplyAPI.ApplySubmit(
          value,
          this.form.otp,
          this.form.captcha
        );
        this.showAlert();
      } catch (error) {
        this.$error(error);
        return;
      } finally {
        this.$hideLoading();
      }
    },
    async showAlert() {
      await this.$alert({
        title: this.$t('Common.message.warmPrompt'),
        message: this.$t('apply.message.subSuccessTip', {
          applicationNo: this.submitData.applicationNo,
        }),
        confirmButtonText: this.$t('apply.button.cheakVoucher'),
      });
      this.$router.push({
        name: `resultPage`,
        params: {
          formData: {
            ...this.form,
            ...this.submitData,
            typeName: this.$route.params.typeName,
            cardNoOrTaxNo: this.form.cardNo.substring(0, 4),
          },
        },
      });
    },
    //預覽
    async handlePreview(file) {
      console.log('預覽', file);
      if (file.url && file.suffix !== 'pdf') {
        if (file.tempId && file.type === 'application/pdf') {
          const base64 = `data:${file.type};base64,${file.byte}`;
          // base64轉blob轉files
          const blob = convertToBlob(base64);
          let url = URL.createObjectURL(blob);
          this.pdfBlobUrl = url;
          this.pdfVisible = true;
          return;
        } else {
          viewImages([file.url]);
          return;
        }
      }
      try {
        this.$showLoading();
        let content = await FileAPI.getDocumentById(file.contentId);
        const mimeType = file.prefix.match(/^data:(.*?);/)[1];
        const base64 = `${file.prefix}${content}`;
        // base64轉blob轉files
        const blob = convertToBlob(base64);
        let url = URL.createObjectURL(blob);
        const files = blobToFiles({
          blob,
          fileName: `${file.originalFileName}.${file.suffix}`,
          type: mimeType,
        });
        file.originFileObj = files;
        file.url = url;
        file.thumbUrl = base64;
        this.form.documentTypes.forEach((file) => {
          file.fileList.forEach((item) => {
            if (item.contentId === file.contentId) {
              item = file;
            }
          });
        });

        if (file.suffix === 'pdf') {
          this.pdfBlobUrl = url;
          this.pdfVisible = true;
        } else {
          viewImages([url]);
        }
      } catch (error) {
        this.$error(error);
      } finally {
        this.$hideLoading();
      }
    },
    handleClose() {
      this.pdfVisible = false;
      // 清理blob URL
      if (this.pdfBlobUrl) {
        URL.revokeObjectURL(this.pdfBlobUrl);
      }
    },
  },
  async created() {
    console.log('====4', this.formData);
    this.form = {
      ...this.formData,
    };
  },
};
</script>
  <style lang="scss" scoped>
.dialogView {
  :deep(.m-dialog) {
    width: 100%;
  }
}
.cellColor :deep(.m-cell-item-value) {
  color: red !important;
}
.collapse-header
  :deep(
    .rainbow__folding__panel.ant-collapse-icon-position-right.ant-collapse
      .ant-collapse-item
      .ant-collapse-header
  ) {
  color: #3d2e38 !important;
}
.cellBreak :deep(.m-cell-item-value) {
  word-break: break-all;
}

.document__item {
  &:first-child .document__title {
    padding-top: 8px;
  }
  & > * {
    margin-bottom: 15px;
  }
  .document__title {
    padding-top: 24px;
    font-weight: 700;
    .document__count {
      display: inline-block;
      min-width: 32px;
      min-height: 32px;
      line-height: 32px;
      background: rgba(var(--m-primary-color-rgb), 0.25);
      text-align: center;
      color: var(--m-primary-color);
      margin-left: 12px;
      border-radius: 16px;
      font-weight: normal;
    }
    .document__limit {
      font-size: var(--subsidiary-font-size);
      font-weight: normal;
      color: #6c6c6c;
      > span {
        margin-right: 12px;
      }
    }
  }
  .tag__orange {
    color: #fa8c16;
    background: #fff7e6;
    border-color: #ffd591;
  }
  .tag__esign {
    border: none;
    padding: 8px 16px;
    border-radius: 18px;
    color: #e0463a;
    background: #ffe8e8;
    font-size: 16px;
    font-weight: 500;
    cursor: inherit;
    margin: 0 10px;
  }
  .ant-upload-list.m-upload-list > div {
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
  }
  .ant-upload-list-item {
    margin: 0;
    border-radius: 8px;
    padding-top: 10px;
    padding-bottom: 10px;
    min-height: 66px;
    height: auto;
    &:hover {
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .ant-upload-list-item-info {
      display: block;
      height: auto;
      > span {
        display: flex;
        height: auto;
      }
    }
    .ant-upload-list-item-name {
      margin-right: 30px;
      white-space: normal;
    }
  }
  .icon__close {
    width: 22px;
    height: 22px;
    background: #a7a8af;
    display: flex;
    justify-content: center;
    border-radius: 50%;
    svg {
      fill: #fff;
    }
  }
}
::v-deep svg.anticon {
  width: 18px;
  fill: #bfbfbf;
  margin-left: 16px;
  cursor: pointer;
}
::v-deep svg.anticon:hover {
  fill: var(--m-primary-color);
}
::v-deep .m-form-item-wrapper .m-form-item-main {
  align-items: inherit;
}
.icon__required::before {
  content: '*';
  left: -10px;
  color: red;
  font-size: var(--normal-font-size);
  line-height: 1.5;
}
.department__tags {
  display: inline-block;
  > span {
    color: var(--m-primary-color);
  }
}
:deep(.input__box) {
  .label-wrapper,
  .label-placeholder {
    width: 35%;
  }
  .label-wrapper label {
    padding-left: 10px;
  }
  .label-wrapper::before {
    left: 0;
    font-weight: bold;
  }
}
:deep(.ant-upload-list-picture .ant-upload-list-item) {
  margin: 8px 8px 0px;
  border-radius: 4px;
  float: left;
  width: 200px;
  background-color: rgba(204, 204, 204, 0.15);
  cursor: pointer;
}
:deep(.ant-upload-list-picture .ant-upload-list-item) {
  background-color: rgba(204, 204, 204, 0.15) !important;
}
:deep(.ant-upload-list-picture .ant-upload-list-item-info > span) {
  background-color: unset;
}
:deep(
    .ant-upload-list-picture
      .ant-upload-list-item-info
      .ant-upload-list-item-card-actions
  ) {
  display: none;
}
</style>
  
  